/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Companion World API
 * API for managing virtual worlds populated with AI-driven agents.

## Overview
The Companion World API provides endpoints for:
- Creating and managing virtual worlds
- Generating populations of AI agents
- Managing agent activities and calendars
- Configuring locations and demographics

## Authentication
Currently, the API operates without authentication. This will be updated in future versions.

## Async Operations
Long-running operations (like population generation) return job IDs for status polling.

 * OpenAPI spec version: 1.0.0
 */

export type LocationType = (typeof LocationType)[keyof typeof LocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationType = {
  residence: 'residence',
  workplace: 'workplace',
  retail: 'retail',
  restaurant: 'restaurant',
  cafe: 'cafe',
  bar: 'bar',
  park: 'park',
  gym: 'gym',
  school: 'school',
  hospital: 'hospital',
  entertainment: 'entertainment',
  transport: 'transport',
  community: 'community',
  religious: 'religious',
  office: 'office',
  other: 'other',
} as const;
